import { useMutation } from '@apollo/client'
import { useToast } from '@winnin/winnin_ui.components.toast'

import useCopyToClipboard from 'hooks/useCopyToClipboard'
import { useTranslate } from 'lib/tolgee'
import { PanelStore, UserStore } from 'stores'
import { TOLGEE_GLOBALS, analyticsTracker } from 'utils'

import { DUPLICATE_DASHBOARD_MUTATION } from './query'

const { DUPLICATE_JOB, WORKSPACE_COPY_LINK } = analyticsTracker.eventNames

function useDashboardOptions() {
  const t = useTranslate()
  const { createToast } = useToast()
  const { copyToClipboard } = useCopyToClipboard()

  const panelName = PanelStore.selectedPanel.name
  const workspaceId = PanelStore?.selectedPanel?.id

  const [duplicateDashboardMutation] = useMutation(DUPLICATE_DASHBOARD_MUTATION, {
    onError(error) {
      console.error('@duplicateJobReport', error)

      createToast({
        content: t(TOLGEE_GLOBALS.requestProblem),
      })
    },
    refetchQueries: ['addToGetWorkspaceJobsPaginated', 'getListWorkspaceJobPaginated'],
  })

  function duplicateDashboard({ id, name, type }) {
    return duplicateDashboardMutation({
      variables: {
        jobId: id,
      },
      onCompleted({ duplicateWorkspaceJob }) {
        if (duplicateWorkspaceJob.success === true) {
          createToast({
            content: t({
              key: `duplicateDashboard-toast`,
              parameters: {
                dashboardName: name || '',
              },
              defaultValue: 'Dashboard {dashboardName} was successfully duplicated!',
            }),
          })

          analyticsTracker.eventTrack(DUPLICATE_JOB, {
            Workspace: panelName,
            'Job name': name,
            'Job type': type,
          })
        } else {
          createToast({
            content: t(TOLGEE_GLOBALS.requestProblem),
          })
        }
      },
    })
  }

  function copyDashboardLink({ id, type }) {
    const copyUrl = `${window.location.origin}/workspace/${workspaceId}/jobs/${id}/dashboard?utm_source=copy_link`
    const currentWorkspace = UserStore.findWorkspace(UserStore.userInfo.brands, workspaceId)

    copyToClipboard({
      textToCopy: copyUrl,
      successText: t({
        key: 'copyDashboardLink-toast',
        parameters: {
          currentWorkspaceName: currentWorkspace.name,
        },
        defaultValue:
          'Link copied! Anyone that have access to the "{currentWorkspaceName}” workspace will be able to open this link.',
      }),
    })

    analyticsTracker.eventTrack(WORKSPACE_COPY_LINK, {
      'Job type': type,
      URL: copyUrl,
    })
  }

  return {
    duplicateDashboard,
    copyDashboardLink,
  }
}

export default useDashboardOptions
